import logger from "@utils/logger";

const ahoy = (event, params = {}) => {
  logger.debug('ahoy', event, params);
  try {
    switch (event) {
      case 'pageView':
        window.ahoy?.trackView(params);
        break;
      case 'identify':
        window.ahoy?.identify();
        break;
      default:
        window.ahoy?.track(event, params);
    }
  } catch (e) {
    logger.debug("ahoy error", e);
  }
};

export default ahoy;
